// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"radish"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16.3001 18.3089C19.4821 15.127 18.775 11.5914 15.593 8.40945C12.411 5.22747 8.87539 4.52028 5.69341 7.70226C3.14783 10.2478 1.80441 14.4199 2.86507 21.1374C9.58259 22.198 13.7545 20.8545 16.3001 18.3089Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.10758 6.99534L9.58245 9.47021M11.7038 16.5412L14.5323 19.3697M3.21849 14.42L5.33981 16.5413M15.9998 8.00022L19.9999 4.00025M20.9998 8.5H16.4998M15.4998 7.5V3M15.593 8.40953C18.775 11.5915 19.4821 15.127 16.3001 18.309C13.7545 20.8546 9.58259 22.1981 2.86507 21.1375C1.80441 14.4199 3.14783 10.2479 5.69341 7.70234C8.87539 4.52036 12.411 5.22755 15.593 8.40953Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const RadishIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'radish',
    ref,
    icon: element,
  },
));

RadishIcon.displayName = 'RadishIcon';

export default RadishIcon;
